/**
 * EnrollmentEmptyState
 *
 * Empty state when no enrollments match filters. Medplum Document-style messaging;
 * Mantine Text. PHI-safe.
 */

import { Button, Stack, Text } from '@mantine/core';

interface EnrollmentEmptyStateProps {
  variant: 'no-enrollments' | 'no-results';
  onClearFilters?: () => void;
  hasActiveFilters?: boolean;
}

export function EnrollmentEmptyState({
  variant,
  onClearFilters,
  hasActiveFilters,
}: EnrollmentEmptyStateProps): JSX.Element {
  const isNoResults = variant === 'no-results';
  return (
    <Stack align="center" gap="sm" py="xl">
      <Text c="dimmed" size="sm">
        {isNoResults
          ? 'No enrollments match your filters.'
          : 'No enrollments on file. Add providers and payers to get started.'}
      </Text>
      {isNoResults && hasActiveFilters && onClearFilters && (
        <Button variant="light" size="xs" onClick={onClearFilters}>
          Clear filters
        </Button>
      )}
    </Stack>
  );
}
